var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultError',{attrs:{"details":{ statusCode: _vm.statusCode, message: _vm.message, title: _vm.message, icon: ['far', 'cloud'] }}})
}
var staticRenderFns = []

export { render, staticRenderFns }